import styled from "styled-components";

export const PillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 71px;
  height: 23px;
  margin-left:15px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: 0;
    padding-left: 0.25rem;
  }
  img {
    padding-bottom: 2px;
  }
  @media only screen and (max-width: 991.92px) {
    margin: 0;
    font-weight: ${props => props.theme.fontWeight.w500};
    align-self: ${props => props.stepper ? 'flex-end': 'center'};
    margin-left: 0;
  }
`;

export const CSRPillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 23px;
  background-color: ${props => props.theme.backgroundColor.oleGeminiColor};
  border: solid 1px ${props => props.theme.border.csrPill};
  border-radius: 1.125rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
  }
  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;

export const DisableCSRPillAnchor = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 23px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
    font-weight: 500;
  }
  @media only screen and (max-width: 991.92px) {
    margin: 0;
    align-self: center;
    margin-left: 0;
  }
`;

export const AddPill = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 203px;
  height: 30px;
  background-color: ${props => props.theme.backgroundColor.pill};
  border: solid 1px ${props => props.theme.border.pill};
  border-radius: 1rem;
  span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    letter-spacing: normal;
    line-height: normal;
    padding-left: 0.25rem;
    line-height:30px;
  }
  @media only screen and (max-width: 991.92px) {
    align-self: center;
    margin-left: 0;
  }
`;
